<div class="table-responsive">
  <a class="btn btn-outline-primary mb-3" (click)="onBackToWinLoseDetail()">
    <i class="bi bi-chevron-left"></i> กลับไปก่อนหน้า
  </a>
  <button class="btn btn-outline-info mb-3 float-end" (click)="getBetDetail()">
    <i class="bi bi-arrow-clockwise"></i> refresh
  </button>

  <span class="d-block">
    BET ID : {{ betId }}
    <span class="float-end">รายการทั้งหมด {{ data?.length || 0 }} รายการ</span>
  </span>

  <div class="form-check form-check-inline">
    <input
      class="form-check-input"
      type="checkbox"
      (change)="allStatus = true; filterStatus()"
      id="inlineCheckbox1"
      value="option1"
      [checked]="allStatus"
    />
    <label class="form-check-label" for="inlineCheckbox1">ทั้งหมด</label>
  </div>
  <div class="form-check form-check-inline">
    <input
      class="form-check-input"
      type="checkbox"
      (change)="allStatus = false; filterStatus()"
      id="inlineCheckbox2"
      value="option2"
      [checked]="!allStatus"
    />
    <label class="form-check-label" for="inlineCheckbox2">ออกผลแล้ว/รออกผล</label>
  </div>

  <table class="table table-hover text-nowrap">
    <thead>
      <tr>
        <th rowspan="2">SUBBET ID</th>
        <th rowspan="2">Timestamp</th>
        <th rowspan="2">Action</th>
        <th>Game/Provider</th>
        <th>Game Datail</th>
        <th>End Round</th>
        <th>Free Round</th>
        <th>Status</th>
        <th>BetType</th>
        <th>Amount</th>
        <th>W/L</th>
        <th rowspan="2">Before Credit</th>
        <th rowspan="2">After Credit</th>
      </tr>
      <tr>
        <th colspan="6">Total</th>
        <th class="text-end fw-bold">{{ summary.amount | number : "1.2-2" }}</th>
        <th
          class="text-end fw-bold"
          [ngClass]="{ 'text-danger': summary.wl < 0, 'text-primary': summary.wl > 0 }"
        >
          {{ summary.wl | number : "1.2-2" }}
          <div class="d-block badge badge-secondary text-end mt-2 mb-2">
            <span class="float-start">bonus</span>
            {{ summary.bonus | number : "1.2-2" }}
          </div>
          {{ summary.wl + summary.bonus | number : "1.2-2" }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of data; let i = index">
        <td class="text-start">
          <i class="bi bi-circle-fill" [ngStyle]="{ color: '#' + getColorRoundId(item) }"></i>
          txnId : {{ item.txnId }}
          <small class="d-block opacity-50"> roundId : {{ item.roundId }} </small>
          <div class="text-end" *ngIf="isAdmin || isSuperAdmin">
            <hr class="my-1" />
            <a class="link-danger" (click)="fixMakeBetCancel(item)">
              <small><i class="bi bi-x-circle"></i> ยกเลิกเดิมพัน</small>
            </a>
          </div>
        </td>
        <td class="text-start">
          เวลาแทง : {{ item.timestamp | date : "dd/MM/yy HH:mm:ss" }} <br />
          เวลาออกผล : {{ item.timestamp_end | date : "dd/MM/yy HH:mm:ss" }}
        </td>
        <td>
          <ng-container *ngIf="item.isPromotionBonus"> BONUS </ng-container>
          <ng-container *ngIf="!item.isPromotionBonus"> W/L </ng-container>
        </td>
        <td class="text-start">
          ชื่อเกม : {{ item.game_name }}
          <small class="d-block opacity-50"> ชื่อค่าย : {{ item.product_id }} </small>
          <small class="d-block opacity-50">
            {{ item.platform }}
          </small>
          <small
            *ngIf="item.userId_sexy"
            class="d-block opacity-50"
            ngxClipboard
            [cbContent]="(item.userId_sexy || '') + ''"
          >
            usergame : {{ item.userId_sexy }}
          </small>
        </td>
        <td>
          <ng-container *ngIf="item.isPromotionBonus">
            <small class="d-block opacity-50">{{ item.info }}</small>
          </ng-container>
          <ng-container *ngIf="!item.isPromotionBonus">
            <a
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#betReplay"
              aria-controls="offcanvasRight"
              (click)="getReplay(item)"
            >
              <strong><u>Bet Detail</u></strong>
            </a>
            <small class="d-block opacity-50" *ngIf="item.winner"
              >Bet Result : {{ item.winner }}</small
            >
          </ng-container>
        </td>
        <td>
          <ng-container *ngIf="item.isEndRound">
            <span class="badge badge-success"> success </span>
          </ng-container>
          <ng-container *ngIf="!item.isEndRound">
            <span class="badge badge-warning">
              <img src="assets/loading-gif.gif" width="10px" alt /> running
            </span>
          </ng-container>
        </td>
        <td>
          <ng-container *ngIf="item.isPromotionBonus"> YES </ng-container>
          <ng-container *ngIf="!item.isPromotionBonus"> NO </ng-container>
        </td>
        <td>
          {{ item.status }}
        </td>
        <td>
          {{ item.betType }}
        </td>

        <td class="text-end fw-bold">{{ item.betAmount | number : "1.2-2" }}</td>
        <td
          class="text-end fw-bold"
          [ngClass]="{
            'text-danger': item.winloseAmount < 0,
            'text-primary': item.winloseAmount > 0
          }"
        >
          <ng-container *ngIf="!item.isPromotionBonus">
            {{ item.winloseAmount || 0 | number : "1.2-2" }}
            <div class="d-block badge badge-secondary text-end mt-2 mb-2">
              <span class="float-start">bonus</span>
              {{ 0 | number : "1.2-2" }}
            </div>
            <u>{{ item.winloseAmount || 0 | number : "1.2-2" }}</u>
          </ng-container>

          <ng-container *ngIf="item.isPromotionBonus">
            {{ 0 | number : "1.2-2" }}
            <div class="d-block badge badge-secondary text-end mt-2 mb-2">
              <span class="float-start">bonus</span>
              {{ item.winloseAmount | number : "1.2-2" }}
            </div>
            <u>{{ item.winloseAmount || 0 | number : "1.2-2" }}</u>
          </ng-container>
        </td>
        <td class="text-end fw-bold">
          {{ item.balanceBefore | number : "1.2-2" }}
        </td>
        <td class="text-end fw-bold">
          <u>{{ item.balanceAfter | number : "1.2-2" }}</u>
        </td>
      </tr>
      <tr>
        <td colspan="9">Total</td>
        <td class="text-end fw-bold">{{ summary.amount | number : "1.2-2" }}</td>
        <td
          class="text-end fw-bold"
          [ngClass]="{ 'text-danger': summary.wl < 0, 'text-primary': summary.wl > 0 }"
        >
          {{ summary.wl | number : "1.2-2" }}
          <div class="d-block badge badge-secondary text-end mt-2 mb-2">
            <span class="float-start">bonus</span>
            {{ summary.bonus | number : "1.2-2" }}
          </div>
          {{ summary.wl + summary.bonus | number : "1.2-2" }}
        </td>
        <td colspan="2"></td>
      </tr>
    </tbody>
  </table>
</div>

<div class="text-center mb-3">
  <div class *ngIf="data && !data.length">{{ "NO_DATA" | translate }}</div>
  <div *ngIf="loadingWinlose"><span class="spinner-border"></span></div>
</div>

<div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  id="betReplay"
  aria-labelledby="offcanvasRightLabel"
>
  <div class="offcanvas-header">
    <h5 id="offcanvasRightLabel">Bet Replay : {{ activeBetReplay?.txnId }}</h5>
    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>
  <div class="offcanvas-body">
    <div class="row">
      <div class="col-12">
        <span class="d-block">Game : {{ activeBetReplay?.game_name }}</span>
        <span class="d-block">Bet Type : {{ activeBetReplay?.betType }}</span>
        <span class="d-block">Status : {{ activeBetReplay?.status }} </span>
      </div>
    </div>
    <hr />
    <ng-container *ngIf="loadingResult == true">
      <h3 class="text-center opacity-50">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        Loading Data...
      </h3>
    </ng-container>
    <ng-container *ngIf="loadingResult == false">
      <ng-container *ngIf="betReplayType == 'url'">
        <iframe
          *ngIf="url"
          [src]="url"
          style="width: 100%; height: 90vh; background-color: white"
          frameborder="0"
        ></iframe>
      </ng-container>
      <ng-container *ngIf="betReplayType == 'json'">
        <!-- <ng-container *ngIf="jsonReplay.betResult?.p">
        </ng-container> -->
        <ng-container *ngIf="RouletteResult && betReplayGame == 'roulette'">
          <div class="d-flex justify-content-center p-4">
            <div class="roulette {{ RouletteResult.textColor }}">
              {{ RouletteResult.textNumber }}
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-6 text-center">
              <h3>Number : {{ RouletteResult.textNumber }}</h3>
            </div>
            <div class="col-6 border-start text-center">
              <h3>Color : {{ RouletteResult.textColor }}</h3>
            </div>
          </div>
          <hr />
        </ng-container>

        <ng-container *ngIf="BacarratResult && betReplayGame == 'baccarat'">
          <div class="row">
            <div class="col-6">
              <div class="text-center text-primary">PLAYER</div>
              <div class="text-center">{{ BacarratResult?.PlayerPoint }} แต้ม</div>
              <div class="text-center">
                <ng-container *ngFor="let data of BacarratResult.Player">
                  <img
                    *ngIf="data.s && data.r"
                    class="ms-2 p-1"
                    src="assets/playing-card/{{ data.s }}-{{ data.r }}.png"
                    width="80px"
                    alt
                  />
                </ng-container>
              </div>
            </div>
            <div class="col-6 border-start">
              <div class="text-center text-danger">BANKER</div>
              <div class="text-center">{{ BacarratResult?.BankerPoint }} แต้ม</div>
              <div class="text-center">
                <ng-container *ngFor="let data of BacarratResult.Banker">
                  <img
                    *ngIf="data.s && data.r"
                    class="ms-2 p-1"
                    src="assets/playing-card/{{ data.s }}-{{ data.r }}.png"
                    width="80px"
                    alt
                  />
                </ng-container>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-12">
              <h1
                class="text-primary text-center"
                *ngIf="BacarratResult.PlayerPoint > BacarratResult.BankerPoint"
              >
                PLAYER WIN
              </h1>
              <h1
                class="text-danger text-center"
                *ngIf="BacarratResult.PlayerPoint < BacarratResult.BankerPoint"
              >
                BANKER WIN
              </h1>
              <h1
                class="text-danger text-center"
                *ngIf="BacarratResult.PlayerPoint == BacarratResult.BankerPoint"
              >
                TIE
              </h1>
            </div>
          </div>
          <hr />
        </ng-container>

        <ng-container *ngIf="DragonTigerResult && betReplayGame == 'dragon-tiger'">
          <div class="row">
            <div class="col-6">
              <div class="text-center text-primary">Dragon</div>
              <div class="text-center">{{ DragonTigerResult?.DragonPoint }} แต้ม</div>
              <div class="text-center">
                <ng-container *ngFor="let data of DragonTigerResult.Dragon">
                  <img
                    *ngIf="data.s && data.r"
                    class="ms-2 p-1"
                    src="assets/playing-card/{{ data.s }}-{{ data.r }}.png"
                    width="80px"
                    alt
                  />
                </ng-container>
              </div>
            </div>
            <div class="col-6 border-start">
              <div class="text-center text-danger">Tiger</div>
              <div class="text-center">{{ DragonTigerResult?.TigerPoint }} แต้ม</div>
              <div class="text-center">
                <ng-container *ngFor="let data of DragonTigerResult.Tiger">
                  <img
                    *ngIf="data.s && data.r"
                    class="ms-2 p-1"
                    src="assets/playing-card/{{ data.s }}-{{ data.r }}.png"
                    width="80px"
                    alt
                  />
                </ng-container>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-12">
              <h1
                class="text-primary text-center"
                *ngIf="DragonTigerResult.DragonPoint > DragonTigerResult.TigerPoint"
              >
                DRAGON WIN
              </h1>
              <h1
                class="text-danger text-center"
                *ngIf="DragonTigerResult.DragonPoint < DragonTigerResult.TigerPoint"
              >
                TIGER WIN
              </h1>
              <h1
                class="text-danger text-center"
                *ngIf="DragonTigerResult.DragonPoint == DragonTigerResult.TigerPoint"
              >
                TIE
              </h1>
            </div>
          </div>
          <hr />
        </ng-container>
      </ng-container>
      <ng-container *ngIf="betReplayType == '' && betReplayGame == ''">
        <h3 class="text-center opacity-50">No Data From Provider</h3>
        <div class="text-center opacity-50">you can view detail on gameplay.</div>
      </ng-container>
    </ng-container>
  </div>
</div>
